import { CustomYup } from 'validations/CustomYup'
import { emailFieldSchema } from '../helpers'

const resetPasswordSchema = CustomYup.object().shape({
  email: emailFieldSchema.required(),
})

export default resetPasswordSchema
